import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DecimalFraction15n0off36xuu9 as DecimalFraction } from '../../math.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { asciiDigitToInt1lum15k9ieezj as asciiDigitToInt } from '../../util.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var FractionPartConsumerClass;
function FractionPartConsumer() {
  if (FractionPartConsumerClass === VOID) {
    class $ extends NumberConsumer() {
      constructor(minLength, maxLength, setter, name) {
        super(minLength === maxLength ? minLength : null, name);
        this.minLength_1 = minLength;
        this.maxLength_1 = maxLength;
        this.setter_1 = setter;
        var containsArg = this.minLength_1;
        // Inline function 'kotlin.require' call
        if (!(1 <= containsArg ? containsArg <= 9 : false)) {
          var message = 'Invalid minimum length ' + this.minLength_1 + ' for field ' + this.whatThisExpects_1 + ': expected 1..9';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var containsLower = this.minLength_1;
        var containsArg_0 = this.maxLength_1;
        // Inline function 'kotlin.require' call
        if (!(containsLower <= containsArg_0 ? containsArg_0 <= 9 : false)) {
          var message_0 = 'Invalid maximum length ' + this.maxLength_1 + ' for field ' + this.whatThisExpects_1 + ': expected ' + this.minLength_1 + '..9';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
      }
      consume_o77i9d_k$(storage, input, start, end) {
        return (end - start | 0) < this.minLength_1 ? new (TooFewDigits())(this.minLength_1) : (end - start | 0) > this.maxLength_1 ? new (TooManyDigits())(this.maxLength_1) : setWithoutReassigning(this.setter_1, storage, new (DecimalFraction())(parseAsciiInt(input, start, end), end - start | 0));
      }
    }
    initMetadataForClass($, 'FractionPartConsumer');
    FractionPartConsumerClass = $;
  }
  return FractionPartConsumerClass;
}
var ConstantNumberConsumerClass;
function ConstantNumberConsumer() {
  if (ConstantNumberConsumerClass === VOID) {
    class $ extends NumberConsumer() {
      constructor(expected) {
        super(expected.length, 'the predefined string ' + expected);
        this.expected_1 = expected;
      }
      consume_o77i9d_k$(storage, input, start, end) {
        var tmp;
        // Inline function 'kotlin.text.substring' call
        if (toString(charSequenceSubSequence(input, start, end)) === this.expected_1) {
          tmp = null;
        } else {
          tmp = new (WrongConstant())(this.expected_1);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ConstantNumberConsumer');
    ConstantNumberConsumerClass = $;
  }
  return ConstantNumberConsumerClass;
}
var NumberConsumerClass;
function NumberConsumer() {
  if (NumberConsumerClass === VOID) {
    class $ {
      constructor(length, whatThisExpects) {
        this.length_1 = length;
        this.whatThisExpects_1 = whatThisExpects;
      }
      get_length_g42xv3_k$() {
        return this.length_1;
      }
    }
    initMetadataForClass($, 'NumberConsumer');
    NumberConsumerClass = $;
  }
  return NumberConsumerClass;
}
var ExpectedIntClass;
function ExpectedInt() {
  if (ExpectedIntClass === VOID) {
    class $ {
      errorMessage_jwdivz_k$() {
        return 'expected an Int value';
      }
    }
    initMetadataForObject($, 'ExpectedInt');
    ExpectedIntClass = $;
  }
  return ExpectedIntClass;
}
var ExpectedInt_instance;
function ExpectedInt_getInstance() {
  return ExpectedInt_instance;
}
var TooManyDigitsClass;
function TooManyDigits() {
  if (TooManyDigitsClass === VOID) {
    class $ {
      constructor(maxDigits) {
        this.maxDigits_1 = maxDigits;
      }
      errorMessage_jwdivz_k$() {
        return 'expected at most ' + this.maxDigits_1 + ' digits';
      }
    }
    initMetadataForClass($, 'TooManyDigits');
    TooManyDigitsClass = $;
  }
  return TooManyDigitsClass;
}
var TooFewDigitsClass;
function TooFewDigits() {
  if (TooFewDigitsClass === VOID) {
    class $ {
      constructor(minDigits) {
        this.minDigits_1 = minDigits;
      }
      errorMessage_jwdivz_k$() {
        return 'expected at least ' + this.minDigits_1 + ' digits';
      }
    }
    initMetadataForClass($, 'TooFewDigits');
    TooFewDigitsClass = $;
  }
  return TooFewDigitsClass;
}
var WrongConstantClass;
function WrongConstant() {
  if (WrongConstantClass === VOID) {
    class $ {
      constructor(expected) {
        this.expected_1 = expected;
      }
      errorMessage_jwdivz_k$() {
        return "expected '" + this.expected_1 + "'";
      }
    }
    initMetadataForClass($, 'WrongConstant');
    WrongConstantClass = $;
  }
  return WrongConstantClass;
}
var ConflictingClass;
function Conflicting() {
  if (ConflictingClass === VOID) {
    class $ {
      constructor(conflicting) {
        this.conflicting_1 = conflicting;
      }
      errorMessage_jwdivz_k$() {
        return "attempted to overwrite the existing value '" + toString(this.conflicting_1) + "'";
      }
    }
    initMetadataForClass($, 'Conflicting');
    ConflictingClass = $;
  }
  return ConflictingClass;
}
function setWithoutReassigning(_this__u8e3s4, receiver, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.trySetWithoutReassigning_itlg4a_k$(receiver, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var conflictingValue = tmp;
  return new (Conflicting())(conflictingValue);
}
function parseAsciiInt(_this__u8e3s4, start, end) {
  var result = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = charSequenceGet(_this__u8e3s4, i);
      result = imul(result, 10) + asciiDigitToInt(digit) | 0;
    }
     while (inductionVariable < end);
  return result;
}
var UnsignedIntConsumerClass;
function UnsignedIntConsumer() {
  if (UnsignedIntConsumerClass === VOID) {
    class $ extends NumberConsumer() {
      constructor(minLength, maxLength, setter, name, multiplyByMinus1) {
        multiplyByMinus1 = multiplyByMinus1 === VOID ? false : multiplyByMinus1;
        super(minLength == maxLength ? minLength : null, name);
        this.minLength_1 = minLength;
        this.maxLength_1 = maxLength;
        this.setter_1 = setter;
        this.multiplyByMinus1__1 = multiplyByMinus1;
        // Inline function 'kotlin.require' call
        if (!(this.get_length_g42xv3_k$() == null || numberRangeToNumber(1, 9).contains_7q95ev_k$(this.get_length_g42xv3_k$()))) {
          var message = 'Invalid length for field ' + this.whatThisExpects_1 + ': ' + this.get_length_g42xv3_k$();
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      consume_o77i9d_k$(storage, input, start, end) {
        var tmp;
        if (!(this.maxLength_1 == null) && (end - start | 0) > this.maxLength_1) {
          tmp = new (TooManyDigits())(this.maxLength_1);
        } else if (!(this.minLength_1 == null) && (end - start | 0) < this.minLength_1) {
          tmp = new (TooFewDigits())(this.minLength_1);
        } else {
          var result = parseAsciiIntOrNull(input, start, end);
          tmp = result == null ? ExpectedInt_instance : setWithoutReassigning(this.setter_1, storage, this.multiplyByMinus1__1 ? -result | 0 : result);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'UnsignedIntConsumer');
    UnsignedIntConsumerClass = $;
  }
  return UnsignedIntConsumerClass;
}
function parseAsciiIntOrNull(_this__u8e3s4, start, end) {
  var result = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = charSequenceGet(_this__u8e3s4, i);
      result = imul(result, 10) + asciiDigitToInt(digit) | 0;
      if (result < 0)
        return null;
    }
     while (inductionVariable < end);
  return result;
}
//region block: init
ExpectedInt_instance = new (ExpectedInt())();
//endregion
//region block: exports
export {
  ConstantNumberConsumer as ConstantNumberConsumer1fkn3mtvfbopz,
  FractionPartConsumer as FractionPartConsumerf0mxqojimz2s,
  UnsignedIntConsumer as UnsignedIntConsumer25zhux255gkqb,
};
//endregion

//# sourceMappingURL=NumberConsumer.mjs.map
